import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { useRouterProps } from '../hooks/useRouterProps';
import { ROUTES } from '@lsgo/lsgo-common/constants/routes';

/**
 * Role-based route guard
 * Only checks roles - authentication should be handled by RouteBuilder
 * This guard assumes auth has already been verified
 */
const RoleRoute = ({ children, render, roles = [], redirectTo, fallback, ...props }) => {
    const permissionsHook = usePermissions();
    const routerProps = useRouterProps();

    // Check roles (auth is handled by RouteBuilder)
    if (roles && roles.length > 0) {
        if (!permissionsHook.hasAnyRole(roles)) {
            return fallback || <Navigate to={redirectTo || ROUTES.AUTH.NO_PERMISSION.path} replace />;
        }
    }

    // All checks passed
    return render ? render({ ...props, ...routerProps }) : children;
};

export default RoleRoute;
